<template>
  <div class="endetajinfo flex">
    <div class="endetleft">
      <div class="anjianheader">
        <div class="ajtitl between">
          <div class="anjibt flex_start">
            <img src="../../../assets/entrust/entruajwticon.png" />
            离婚时用老婆名字注册的店面要如何分割
          </div>
          <div class="fbtime">发布时间：2021-04-29</div>
        </div>

        <div class="anjizw">(仅发布用户及律师用户可查看全部内容!)</div>
        <div class="anjizw dl" v-if="false">
          离婚时用老婆名字注册的店面要如何分割离婚时用老婆名字注册的店面要如何分割离婚时用老婆名字注册的店面要如何分割离婚时用老婆名字注册的店面要如何分割离婚时用老婆名字注册的店面要如何分割离婚时用老婆名字注册的店面要如何分割
        </div>
      </div>
      <div class="lawhd">
        <div class="hdtitl flex_start">
          <img src="../../../assets/entrust/entrylsjdicon.png" />
          律师解答
        </div>
        <div class="lawhdcont">***** (仅发布用户及律师用户可查看全部内容!)</div>
      </div>
    </div>
    <div class="endetright">
      <div class="righttitle bomborder">案件信息</div>

      <div class="infoitem bomborder flex_start">
        <div class="label">涉案金额</div>
        <div class="dynr ori">10万以下</div>
      </div>
      <div class="infoitem bomborder flex_start">
        <div class="label">涉案金额</div>
        <div class="dynr">面议</div>
      </div>
      <div class="infoitem bomborder flex_start">
        <div class="label">案件地区</div>
        <div class="dynr">广东-东莞</div>
      </div>
      <div class="infoitem bomborder flex_start">
        <div class="label">联系人</div>
        <div class="dynr">王**</div>
      </div>
      <div class="infoitem bomborder flex_start">
        <div class="label">电话号码</div>
        <div class="dynr">137********</div>
      </div>
      <div class="infoitem bomborder flex_start">
        <div class="label">电子邮件</div>
        <div class="dynr">***</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.endetajinfo {
  width: 1200px;
  height: 374px;
  box-shadow: 0px 0px 8px 0px rgba(1, 1, 1, 0.08);
  .endetleft {
    width: 850px;
    border-right: 1px solid #ccc;
    padding: 26px 20px;
    .anjianheader {
      padding-bottom: 40px;
      border-bottom: 1px solid #eee;
      .ajtitl {
        .anjibt {
          img {
            width: 32px;
            height: 32px;
            margin-right: 10px;
          }
          font-size: 20px;
          color: #333333;
        }

        .fbtime {
          font-size: 14px;
          color: #aaaaaa;
          margin-right: 10px;
        }
      }
      .anjizw {
        margin-top: 10px;
        font-size: 14px;
        color: #999999;
        padding-left: 40px;
        &.dl {
          line-height: 22px;
          text-indent: 2em;
        }
      }
    }
    .lawhd {
      margin-top: 50px;
      .hdtitl {
        font-size: 20px;
        color: #333333;
        img {
          width: 28px;
          height: 26px;
          margin-right: 10px;
        }
      }
      .lawhdcont {
        padding-left: 40px;
        margin-top: 30px;
        font-size: 16px;
        color: #63aeff;
      }
    }
  }
  .endetright {
    width: 350px;
    .bomborder {
      border-bottom: 1px solid #eeeeee;
    }
    .righttitle {
      padding: 12px 20px;
      font-size: 20px;
      color: #333;
    }
    .infoitem {
      padding: 12.5px 20px;
      font-size: 18px;
      color: #aaaaaa;
      .label {
        width: 110px;
      }
      .dynr {
        flex: 1;
        &.ori {
          color: #ff6600;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>